import { IChannel } from './types';

export enum Channel {
	RENTALS_UNITED = 'rentalsunited.com',
	RENTALS_UNITED_AIRBNB = 'rentalsunited.com:airbnb.com',
	RENTALS_UNITED_DESPEGAR = 'rentalsunited.com:despegar.com.ar',
	RENTALS_UNITED_EDOMIZIL = 'rentalsunited.com:e-domizil.com',
	RENTALS_UNITED_EXPEDIA = 'rentalsunited.com:expedia.com',
	RENTALS_UNITED_HOMEAWAY = 'rentalsunited.com:homeaway.co.uk',
	RENTALS_UNITED_TOURICO = 'rentalsunited.com:touricoholidays.com',
	RENTALS_UNITED_TRIPADVISOR = 'rentalsunited.com:tripadvisor.com',

	// AirBnB
	AIRBNB = 'airbnb.com',

	// Booking.com direct
	BOOKINGCOM = 'booking.com',
	BOOKINGCOM_AGODA = 'booking.com:agoda.com',
	BOOKINGCOM_KAYAK = 'booking.com:kayak.com',
	BOOKINGCOM_PRICELINE = 'booking.com:priceline.com',

	// RU Booking.com & affiliates
	RENTALS_UNITED_BOOKINGCOM = 'rentalsunited.com:booking.com',
	RENTALS_UNITED_BOOKINGCOM_AGODA = 'rentalsunited.com:booking.com:agoda.com',
	RENTALS_UNITED_BOOKINGCOM_KAYAK = 'rentalsunited.com:booking.com:kayak.com',
	RENTALS_UNITED_BOOKINGCOM_PRICELINE = 'rentalsunited.com:booking.com:priceline.com',

	// Expedia & affiliates
	EXPEDIA = 'expedia.com',
	EXPEDIA_HOTELSCOM = 'expedia.com:hotels.com',
	EXPEDIA_EXPEDIA_AFFILIATE_NETWORK = 'expedia.com:expediaaffiliatenetwork',
	EXPEDIA_EGENCIA = 'expedia.com:egencia.com',
	EXPEDIA_TRAVELOCITY = 'expedia.com:travelocity.com',
	EXPEDIA_ORBITZ = 'expedia.com:orbitz.com',
	EXPEDIA_WOTIF = 'expedia.com:wotif.com',
	EXPEDIA_HOTWIRE = 'expedia.com:hotwire.com',
	EXPEDIA_CHEAPTICKETS = 'expedia.com:cheaptickets.com',
	EXPEDIA_EBOOKERS = 'expedia.com:ebookers.com',
	EXPEDIA_MRJET = 'expedia.com:mrjet.com',
	EXPEDIA_LASTMINUTEAU = 'expedia.com:lastminute.au',
	EXPEDIA_AMERICAN_EXPRESS_TRAVEL = 'expedia.com:americanexpresstravel',
	EXPEDIA_AMEX_THE_HOTEL_COLLECTION = 'expedia.com:amexthehotelcollection',
	EXPEDIA_AMEX_FINE_HOTELS_AND_RESORTS = 'expedia.com:amexfinehotelsandresorts',
	EXPEDIA_THOMAS_COOK = 'expedia.com:thomascook.com',
	EXPEDIA_NECKERMANN = 'expedia.com:neckermann.de',
	EXPEDIA_VING = 'expedia.com:ving.se',
	EXPEDIA_TJAREBORG = 'expedia.com:tjareborg.fi',
	EXPEDIA_SPIES = 'expedia.com:spies.dk',

	// Holidu
	HOLIDU = 'holidu.co.uk',

	// HomeAway & affiliates
	HOMEAWAY = 'homeaway.co.uk',
	HOMEAWAY_ARBITEL = 'homeaway.co.uk:arbitel.fr',
	HOMEAWAY_VRBO = 'homeaway.co.uk:vrbo.com',
	HOMEAWAY_EXPEDIA = 'homeaway.co.uk:expedia.com',
	HOMEAWAY_US = 'homeaway.co.uk:homeaway.com',
	HOMEAWAY_AT = 'homeaway.co.uk:homeaway.at',
	HOMEAWAY_NZ = 'homeaway.co.uk:homeaway.co.nz',
	HOMEAWAY_AU = 'homeaway.co.uk:homeaway.com.au',
	HOMEAWAY_ES = 'homeaway.co.uk:homeaway.es',
	HOMEAWAY_IT = 'homeaway.co.uk:homeaway.it',
	HOMEAWAY_JP = 'homeaway.co.uk:homeaway.jp',
	HOMEAWAY_PT = 'homeaway.co.uk:homeaway.pt',
	HOMEAWAY_SG = 'homeaway.co.uk:homeaway.sg',

	// HomeToGo
	HOMETOGO = 'hometogo.com',

	// TripAdvisor & affiliates
	TRIPADVISOR = 'tripadvisor.com',
	TRIPADVISOR_FLIPKEY = 'tripadvisor.com:flipkey.com',
	TRIPADVISOR_HOUSETRIP = 'tripadvisor.com:housetrip.com',
	TRIPADVISOR_HOLIDAYLETTINGS = 'tripadvisor.com:holidaylettings.com',

	// TUI & affiliates
	RENTALS_UNITED_TUI = 'rentalsunited.com:tuivillas.com',
	RENTALS_UNITED_TUI_ATRAVEO = 'rentalsunited.com:tuivillas.com:atraveo.com',

	// Plum Guide
	PLUM_GUIDE = 'plumguide.com',

	// Travelnest Direct
	TRAVELNEST = 'direct',
	TRAVELNEST_GOOGLEVR = 'direct:googlevr',
}

export enum selectableChannels {
	AIRBNB = 'airbnb.com',
	BOOKINGCOM = 'booking.com',
	EXPEDIA = 'expedia.com',
	HOLIDU = 'holidu.co.uk',
	HOMEAWAY = 'homeaway.co.uk',
	HOMETOGO = 'hometogo.com',
	TRIPADVISOR = 'tripadvisor.com',
	TRAVELNEST = 'direct',
}

export const channelFriendlyNames = {
	// Used for both internal and external display

	[Channel.RENTALS_UNITED]: 'Rentals United',

	[Channel.RENTALS_UNITED_AIRBNB]: 'Airbnb',
	[Channel.RENTALS_UNITED_DESPEGAR]: 'Despegar',
	[Channel.RENTALS_UNITED_EDOMIZIL]: 'E-domizil',
	[Channel.RENTALS_UNITED_EXPEDIA]: 'Expedia',
	[Channel.RENTALS_UNITED_HOMEAWAY]: 'VRBO',
	[Channel.RENTALS_UNITED_TOURICO]: 'Tourico',
	[Channel.RENTALS_UNITED_TRIPADVISOR]: 'TripAdvisor',

	// AirBnB
	[Channel.AIRBNB]: 'Airbnb',

	// Booking.com direct
	[Channel.BOOKINGCOM]: 'Booking.com',
	[Channel.BOOKINGCOM_AGODA]: 'Agoda',
	[Channel.BOOKINGCOM_KAYAK]: 'Kayak',
	[Channel.BOOKINGCOM_PRICELINE]: 'Priceline',

	// RU Booking.com & affiliates
	[Channel.RENTALS_UNITED_BOOKINGCOM]: 'Booking.com',
	[Channel.RENTALS_UNITED_BOOKINGCOM_AGODA]: 'Agoda',
	[Channel.RENTALS_UNITED_BOOKINGCOM_KAYAK]: 'Kayak',
	[Channel.RENTALS_UNITED_BOOKINGCOM_PRICELINE]: 'Priceline',

	// Holidu
	[Channel.HOLIDU]: 'Holidu',

	// HomeAway & affiliates
	[Channel.HOMEAWAY]: 'VRBO',
	[Channel.HOMEAWAY_ARBITEL]: 'Arbitel',

	// HomeToGo
	[Channel.HOMETOGO]: 'HomeToGo',

	// Expedia & affiliates
	[Channel.EXPEDIA]: 'Expedia',
	[Channel.EXPEDIA_HOTELSCOM]: 'Hotels.com',
	[Channel.EXPEDIA_EXPEDIA_AFFILIATE_NETWORK]: 'Expedia Affiliate Network',
	[Channel.EXPEDIA_EGENCIA]: 'Egencia',
	[Channel.EXPEDIA_TRAVELOCITY]: 'Travelocity',
	[Channel.EXPEDIA_ORBITZ]: 'Orbitz',
	[Channel.EXPEDIA_WOTIF]: 'Wotif',
	[Channel.EXPEDIA_HOTWIRE]: 'Hotwire',
	[Channel.EXPEDIA_CHEAPTICKETS]: 'CheapTickets',
	[Channel.EXPEDIA_EBOOKERS]: 'ebookers',
	[Channel.EXPEDIA_MRJET]: 'MrJet',
	[Channel.EXPEDIA_LASTMINUTEAU]: 'Lastminute.au',
	[Channel.EXPEDIA_AMERICAN_EXPRESS_TRAVEL]: 'American Express Travel',
	[Channel.EXPEDIA_AMEX_THE_HOTEL_COLLECTION]: 'Amex The Hotel Collection',
	[Channel.EXPEDIA_AMEX_FINE_HOTELS_AND_RESORTS]: 'Amex Fine Hotels and Resorts',
	[Channel.EXPEDIA_THOMAS_COOK]: 'Thomas Cook',
	[Channel.EXPEDIA_NECKERMANN]: 'Neckermann',
	[Channel.EXPEDIA_VING]: 'Ving',
	[Channel.EXPEDIA_TJAREBORG]: 'Tjareborg',
	[Channel.EXPEDIA_SPIES]: 'Spies',

	// TripAdvisor & affiliates
	[Channel.TRIPADVISOR]: 'TripAdvisor',
	[Channel.TRIPADVISOR_FLIPKEY]: 'FlipKey',
	[Channel.TRIPADVISOR_HOUSETRIP]: 'HouseTrip',
	[Channel.TRIPADVISOR_HOLIDAYLETTINGS]: 'HolidayLettings',

	// TUI & affiliates
	[Channel.RENTALS_UNITED_TUI]: 'TUI',
	[Channel.RENTALS_UNITED_TUI_ATRAVEO]: 'Atraveo',

	// Plum Guide
	[Channel.PLUM_GUIDE]: 'Plum Guide',

	// Travelnest Direct
	[Channel.TRAVELNEST]: 'Travelnest Direct',
	[Channel.TRAVELNEST_GOOGLEVR]: 'Travelnest Direct'
};

export const getAffiliates = (channelId: string) => {
	const filteredChannelList =
		Object.entries(channelFriendlyNames).filter((ch) => ch[0].startsWith(channelId) && ch[0] !== channelId);
	const aff = filteredChannelList.map((cl) => cl[1]);
	return aff;
};

export const channels: IChannel[] = [
	{
		id: Channel.TRAVELNEST,
		ref: 'travelnest',
		display_name: 'Direct Booking',
		description: 'Take bookings directly from guests with your own website.',
		whiteLogo: '/71eb904/assets/images/tn-direct.png',
		colorLogo: '/71eb904/assets/images/logo-beta.svg',
		brandedLogo: '/71eb904/assets/images/channels/channel_color_direct.png',
		primaryColor: '#00AF87',
		additional_info: [],
		active: true,
		affiliates: 0,
	},
	{
		id: Channel.AIRBNB,
		ref: 'airbnb',
		display_name: 'Airbnb',
		description: 'A global brand name that\'s popular for short-term homestays and local tourism experiences.',
		whiteLogo: '/71eb904/assets/images/channels/airbnb_white.svg',
		colorLogo: '/71eb904/assets/images/channels/airbnb_color.svg',
		brandedLogo: '/71eb904/assets/images/channels/channel_color_airbnb.png',
		primaryColor: '#FF5A5F',
		additional_info: [
			'79 million visitors a year',
			'Payment received before guest arrival',
		],
		active: true,
		affiliates: 0,
		highlightText: 'POPULAR CHOICE'
	},
	{
		id: Channel.BOOKINGCOM,
		ref: 'bookingcom',
		display_name: 'Booking.com',
		description: 'The world\'s biggest travel/fare aggregator and search engine for holiday accommodation.',
		whiteLogo: '/71eb904/assets/images/channels/bookingcom_white.svg',
		colorLogo: '/71eb904/assets/images/channels/bookingcom_color.svg',
		brandedLogo: '/71eb904/assets/images/channels/channel_color_bcom.png',
		primaryColor: '#003580',
		additional_info: [
			'443 million visitors a year',
			'Payment received at time of booking',
		],
		active: true,
		affiliates: 0,
		highlightText: 'HIGH PERFORMER'
	},
	{
		id: Channel.EXPEDIA,
		ref: 'expedia',
		display_name: 'Expedia',
		description: 'A leading travel company with a large network of subsidiary channels.',
		whiteLogo: '/71eb904/assets/images/channels/expedia_white.svg',
		colorLogo: '/71eb904/assets/images/channels/expedia_color.svg',
		brandedLogo: '/71eb904/assets/images/channels/channel_color_expedia.png',
		primaryColor: '#00355F',
		additional_info: [
			'62 million visitors a year',
			'Payment received upon guest arrival',
		],
		active: true,
		affiliates: 18
	},
	{
		id: Channel.HOLIDU,
		ref: 'holidu',
		display_name: 'Holidu',
		description: 'A worldwide vacation rental search engine with over 30 million users per month.',
		whiteLogo: '/71eb904/assets/images/channels/holidu_white.svg',
		colorLogo: '/71eb904/assets/images/channels/holidu_white.svg',
		brandedLogo: '/71eb904/assets/images/channels/channel_color_holidu.png',
		primaryColor: '#0C6EEF',
		additional_info: [
			'Over 100 million site visits per year',
		],
		active: true,
		affiliates: 0
	},
	{
		id: Channel.HOMEAWAY,
		ref: 'homeaway',
		display_name: 'VRBO',
		description: 'Focuses on short-term rental of entire vacation homes and higher end villas.',
		whiteLogo: '/71eb904/assets/images/channels/vrbo_white.svg',
		colorLogo: '/71eb904/assets/images/channels/homeaway_color.svg',
		brandedLogo: '/71eb904/assets/images/channels/channel_color_vrbo.png',
		primaryColor: '#00214B',
		additional_info: [
			'8 million visitors a year',
			'Payment received at time of booking',
		],
		active: true,
		affiliates: 2
	},
	{
		id: Channel.HOMETOGO,
		ref: 'hometogo',
		display_name: 'HomeToGo',
		description: "HomeToGo is the marketplace with the world's largest selection of holiday homes. A global brand name that's making incredible homes easily accessible to everyone.",
		whiteLogo: '/71eb904/assets/images/channels/hometogo_color.svg', // the color variant is the one we want to use as approved by design
		colorLogo: '/71eb904/assets/images/channels/hometogo_color.svg',
		brandedLogo: '/71eb904/assets/images/channels/hometogo_branded.svg',
		primaryColor: '#00214B',
		additional_info: [], // unused
		active: true,
		affiliates: 0
	},
	{
		id: Channel.TRIPADVISOR,
		ref: 'tripadvisor',
		display_name: 'TripAdvisor',
		description: 'The go-to site for traveller reviews is also a key booking and price comparison site.',
		whiteLogo: '/71eb904/assets/images/channels/tripadvisor_white.svg',
		colorLogo: '/71eb904/assets/images/channels/tripadvisor_color.svg',
		brandedLogo: '/71eb904/assets/images/channels/channel_color_tripadvisor.png',
		primaryColor: '#00AF87',
		additional_info: [
			'175 million visitors a year',
			'Payment received after guest arrival',
		],
		active: true,
		affiliates: 3
	}
];

export type TermIds = 'terms20200318' | 'privacy20200318';

export interface ITerms {
	termsId: TermIds;
	termsName: string;
	termsUrl: string;
}

export const SignupTermsConditions = [
	{
		termsId: 'terms20200318',
		termsName: 'Travelnest terms and conditions',
		termsUrl: 'https://travelnest.freshdesk.com/support/solutions/articles/101000365056-travelnest-terms-and-conditions'
	},
	{
		termsId: 'privacy20200318',
		termsName: 'Travelnest privacy policy',
		termsUrl: 'https://travelnest.freshdesk.com/support/solutions/articles/101000374929-travelnest-privacy-policy'
	}
] as ReadonlyArray<ITerms>;
